import { render, staticRenderFns } from "./DependentInformation.vue?vue&type=template&id=1a25de0a&scoped=true"
import script from "./DependentInformation.vue?vue&type=script&lang=js"
export * from "./DependentInformation.vue?vue&type=script&lang=js"
import style0 from "./DependentInformation.vue?vue&type=style&index=0&id=1a25de0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a25de0a",
  null
  
)

export default component.exports